import {
  TextField,
  Box,
  Typography,
  FormControl,
  FormLabel,
  Button,
  IconButton,
  FormControlLabel,
  Tooltip,
  Checkbox,
  InputLabel,
  Select,
  MenuItem,
  LinearProgress,
  Paper,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import { Field, Formik } from "formik";
import { CheckBox } from "@mui/icons-material";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { gradeSchema } from "../../Security/validation";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import * as Yup from "yup";
import {
  fetchApidata,
  getCheckIn,
  getFetchData,
  postApidata,
  postData,
} from "../../../store/reducers/Formapireducer";
import React, { useState, useEffect, useRef } from "react";
import { LoadingButton } from "@mui/lab";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
// import {  HsnSchema } from "../../Security/validation";
import Popup from "../popup";
import Listviewpopup from "../Lookup";
import { CheckinAutocomplete, Productautocomplete } from "../../../ui-components/global/Autocomplete";
import { formGap } from "../../../ui-components/global/utils";
// import ErrorMsgData from "../../Security/validationMsg.json"

// // import CryptoJS from "crypto-js";
// const validationSchema = Yup.object().shape({
//   location: Yup.object().required(ErrorMsgData.CheckOut.location).nullable(),
//   gate: Yup.object().required(ErrorMsgData.CheckOut.gate).nullable(),
//   // date: Yup.string().required(ErrorMsgData.CheckOut.date),
//   // checkouttype: Yup.string().required(ErrorMsgData.CheckOut.checkouttype),
//   // checkouttime: Yup.string().required(ErrorMsgData.CheckOut.checkouttime),
//    comment: Yup.string().required(ErrorMsgData.CheckOut.comment),
// });
const Editcheckout = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  let params = useParams();
  console.log("🚀 ~ file: Editcheckout.jsx:45 ~ Editcheckout ~ params:", params)
  const dispatch = useDispatch();
  const sourcename = "Cloud";
  var recID = params.id;
  var mode = params.Mode;
  var accessID = params.accessID;
  const data = useSelector((state) => state.formApi.Data);
  const Status = useSelector((state) => state.formApi.Status);
  const Msg = useSelector((state) => state.formApi.msg);
  const isLoading = useSelector((state) => state.formApi.postLoading);
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const YearFlag = sessionStorage.getItem("YearFlag");
  const checkInOutData = useSelector((state) => state.formApi.checkInOutData);
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const Year = sessionStorage.getItem("year");
  var CompanyID = sessionStorage.getItem("compID");
  const EMPID = sessionStorage.getItem("EmpId");
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const location = useLocation();
  const [errorMsgData, setErrorMsgData] = useState(null);
  const [validationSchema, setValidationSchema] = useState(null);

  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  console.log(SubscriptionCode, is003Subscription, "SubscriptionCode");


  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
        const schema = Yup.object().shape({
          // location: Yup.object().required(data.CheckOut.location).nullable(),
          // gate: Yup.object().required(data.CheckOut.gate).nullable(),
          comment: Yup.string().trim().required(data.CheckOut.comment),
        });

        setValidationSchema(schema);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, []);
  useEffect(() => {
    // mode == "A" ? dispatch(getCheckIn({ HeaderID: EMPID })) :
    dispatch(getFetchData({ accessID, get: "get", recID }));

  }, [location.key]);
  const style = {
    height: "55px",
    border: "2px solid #1769aa ",
    borderRadius: "5px",
    backgroundColor: "#EDEDED",
  };
  const [locgate, setLocgate] = useState(null);
  // *************** INITIALVALUE  *************** //
  const getCurrentTime = () => {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`; // "HH:mm"
  };

  function getLocalDate() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const date = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${date}`;
  }

  const [time, setTime] = useState(getCurrentTime());
  const [currentData, setCurrentData] = useState(getLocalDate());
  // console.log("🚀 ~ Editcheckout ~ currentData:", currentData)



  useEffect(() => {
    if (mode == "A") {
      const interval = setInterval(() => {
        const now = new Date();

        const today = getLocalDate();
        if (today !== currentData) {
          setCurrentData(getLocalDate());
        }
        setTime(getCurrentTime());

      }, 1000); // update every second

      return () => clearInterval(interval); // cleanup on unmount
    }

  }, []);

  console.log("🚀 ~ Editcheckout ~ currentData == data.HiddenDate:", currentData == data.HiddenDate)
  console.log("🚀 ~ Editcheckout ~ currentData:", currentData)
  console.log("🚀 ~ Editcheckout ~ data.HiddenDate:", data.HiddenDate)
  // currentData == data.HiddenDate


  const InitialValue = {
    checkouttype: mode == "A" ? "R" : data.CheckOutType,
    date: mode == "A" ? currentData : currentData == data.HiddenDate ? data.HiddenDate : currentData,
    comment: data.CheckOutComment,
    checkouttime: data.CheckOutTime == null ? time : data.CheckOutTime,
    lcidate: mode == "A" ? checkInOutData.LatestCheckOutTime : data.LatestCheckinDate,
    location: data.LocationRecID ? { RecordID: data.LocationRecID, Name: data.LocationName } : { RecordID: 0, Name: "" },
    gate: data.GateRecID ? { RecordID: data.GateRecID, Name: data.GateName } : { RecordID: 0, Name: "" },
  };

  const Fnsave = async (values) => {
    let action = "update";

    const idata = {
      RecordID: recID,
      CheckOutType: mode == "E" || mode == "A" ? "R" : values.checkouttype,
      // CheckOutType: values.checkouttype,
      CheckOutDate: values.date,
      CheckOutComment: values.comment,
      EmployeeID: EMPID,
      // LocationRecID: locationLookup.locationRecordID,
      // GateRecID: gateLookup.gateRecordID,
      LocationRecID: values.location.RecordID || 0,
      LocationName: values.location.Name || "",
      GateRecID: values.gate.RecordID || 0,
      GateName: values.gate.Name || "",
      CheckOutTime: values.checkouttime,
      CheckInTime: values.checkintime,
      LatestCheckinDate: '0',
      Source: sourcename,
      //CompanyID
    };

    const response = await dispatch(postData({ accessID, action, idata }));
    if (response.payload.Status == "Y") {
      toast.success(response.payload.Msg);
      navigate("/Apps/TR124/Check Out");
    } else {
      toast.error(response.payload.Msg);
    }
  };
  const [isPopupData, setisPopupdata] = React.useState(false);
  const [selectEMPLOYEELookupData, setselectEMPLOYEELookupData] =
    React.useState({
      EMPLOYEElookupRecordid: "",
      EMPLOYEElookupCode: "",
      EMPLOYEElookupDesc: "",
    });
  const [locationLookup, SetLocationLookup] = useState({
    locationRecordID: "",
    locationCode: "",
    locationName: "",
  });
  const [gateLookup, SetGateLookup] = useState({
    gateRecordID: "",
    gateCode: "",
    gateName: "",
  });
  if (isPopupData == false) {
    selectEMPLOYEELookupData.EMPLOYEElookupRecordid = data.EmployeeID;
    selectEMPLOYEELookupData.EMPLOYEElookupCode = data.EmployeeCode;
    selectEMPLOYEELookupData.EMPLOYEElookupDesc = data.EmployeeName;

    //Location
    locationLookup.locationRecordID = mode == "A" ? checkInOutData.LocationRecID : data.LocationRecID;
    locationLookup.locationCode = mode == "A" ? checkInOutData.LocationCode : data.LocationCode;
    locationLookup.locationName = mode == "A" ? checkInOutData.LocationName : data.LocationName;

    //Gate
    gateLookup.gateRecordID = mode == "A" ? checkInOutData.GateRecID : data.GateRecID;
    gateLookup.gateCode = mode == "A" ? checkInOutData.GateCode : data.GateCode;
    gateLookup.gateName = mode == "A" ? checkInOutData.GateName : data.GateName;
  }

  const [openEMPLOYEEPopup, setOpenEMPLOYEEPopup] = useState(false);
  const [openLOCATIONPopup, setOpenLOCATIONPopup] = useState(false);
  const [openGATEPopup, setOpenGATEPopup] = useState(false);
  function handleShow(type) {
    if (type == "EMPLOYEE") {
      setOpenEMPLOYEEPopup(true);
    }
    if (type == "LOCATION") {
      setOpenLOCATIONPopup(true);
    }
    if (type == "GATE") {
      setOpenGATEPopup(true);
    }
  }
  /************************** Lookup value assign type based Function *****************/
  const childToParent = (childdata, type) => {


    if (type == "Employee") {
      setisPopupdata(true);
      setselectEMPLOYEELookupData({
        EMPLOYEElookupRecordid: childdata.RecordID,
        EMPLOYEElookupCode: childdata.Code,
        EMPLOYEElookupDesc: childdata.Name,
      });
      setOpenEMPLOYEEPopup(false);
    }
    if (type == "Location") {
      setisPopupdata(true);
      SetLocationLookup({
        locationCode: childdata.Code,
        locationName: childdata.Name,
        locationRecordID: childdata.RecordID,
      });
      // console.log(locationLookup)
      setOpenLOCATIONPopup(false);
    }
    if (type == "Gate") {
      setisPopupdata(true);
      SetGateLookup({
        gateRecordID: childdata.RecordID,
        gateCode: childdata.Code,
        gateName: childdata.Name,
      });

      setOpenGATEPopup(false);
    }
  };

  const fnLogOut = (props) => {
    Swal.fire({
      // title: `Do you want ${props}?`,
      // text:data.payload.Msg,
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate("/Apps/TR124/Check Out");
        }
      } else {
        return;
      }
    });
  };



  const CompId = sessionStorage.getItem("companyId");
  return (
    <React.Fragment>
      {getLoading ? <LinearProgress /> : false}
      <Paper elevation={3} sx={{ margin: "0px 5px", background: "#fcfcfc",height:"40px" }}>
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Typography variant="h3" sx={{
              marginLeft:"10px",fontSize:"19px",color: "#0000D1" 
            }}>

              {is003Subscription ? "Out Time" :"Check Out"}
              
            </Typography>
          </Box>
          <Box display="flex">
            {/* <Tooltip title="Check Out ">
            <IconButton onClick={() => navigate('/Apps/TR124/Check%20Out')} color="primary">
              <ListAltOutlinedIcon />
            </IconButton>
          </Tooltip> */}
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>
      {!getLoading ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          {/* <Box m="20px"> */}
          <Formik
            initialValues={InitialValue}
            onSubmit={(values, setSubmitting) => {
              setTimeout(() => {
                Fnsave(values);
              }, 100);
            }}
            validationSchema={validationSchema}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue
            }) => (

              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(4 , minMax(0,1fr))"
                  // gap="30px"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <FormControl
                    sx={{
                      gridColumn: "span 2",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <CheckinAutocomplete
                      name="location"
                      label="Location"
                      id="location"
                      value={values.location}
                      onChange={(newValue) => {
                        setFieldValue("location", newValue);
                      }}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2051","ScreenName":"Location","Filter":"parentID=${CompId}","Any":""}}`}
                      error={!!touched.location && !!errors.location}
                      helperText={touched.location && errors.location}
                    />
                  </FormControl>

                  <FormControl
                    sx={{
                      gridColumn: "span 2",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <CheckinAutocomplete
                      name="gate"
                      label="Gate"
                      id="gate"
                      value={values.gate}
                      onChange={(newValue) => {
                        setFieldValue("gate", newValue);
                      }}
                      error={!!touched.gate && !!errors.gate}
                      helperText={touched.gate && errors.gate}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2050","ScreenName":"Gate","Filter":"parentID=${values?.location?.RecordID}","Any":""}}`}
                    />
                  </FormControl>

                  <TextField
                    name="date"
                    type="date"
                    id="date"
                    label="Check Out Date"
                    variant="standard"
                    focused
                    disabled
                    value={values.date}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.date && !!errors.date}
                    helperText={touched.date && errors.date}
                    sx={{ gridColumn: "span 2" }}
                    inputProps={{ max: currentData }}
                    InputLabelProps={{ shrink: true }}
                  />



                  <TextField
                    name="checkouttime"
                    type="time"
                    label="Check Out Time"
                    variant="standard"
                    value={values.checkouttime}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    placeholder="hh:mm AM/PM"
                    sx={{ gridColumn: "span 2" }}
                    inputProps={{ step: 60 }}
                    disabled
                  />

                  <FormControl
                    focused
                    variant="standard"
                    sx={{ gridColumn: "span 2" }}
                  >
                    <InputLabel id="status">Type</InputLabel>
                    <Select
                      labelId="demo-simple-select-filled-label"
                      id="checkouttype"
                      name="checkouttype"
                      value={(mode == "E" || mode == "A") ? "R" : values.checkouttype}
                      // value={values.checkouttype}
                      // required
                      onBlur={handleBlur}
                      onChange={handleChange}
                      inputProps={{ readOnly: true }}
                    >
                      <MenuItem value="R">Regular</MenuItem>
                      <MenuItem value="L">Late</MenuItem>
                      <MenuItem value="P">Permission</MenuItem>
                      <MenuItem value="O">Onduty</MenuItem>
                      <MenuItem value="V">Leave</MenuItem>
                    </Select>
                  </FormControl>

                  {/* <TextField
                    name="lcidate"
                    type="date"
                    id="lcidate"
                    label="Last Check In Date"
                    variant="standard"
                    focused
                    inputFormat="YYYY-MM-DD"
                    value={values.lcidate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.lcidate && !!errors.lcidate}
                    helperText={touched.lcidate && errors.lcidate}
                    sx={{ gridColumn: "span 2" }}
                  /> */}
                  <TextField
                    name="comment"
                    type="text"
                    id="comment"
                    label={
                      <>
                        Check Out Comment<span style={{ color: "red", fontSize: "20px" }}> * </span>
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.comment}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.comment && !!errors.comment}
                    helperText={touched.comment && errors.comment}
                    sx={{ gridColumn: "span 2" }}
                  />
                </Box>
                <Box display="flex" justifyContent="end" padding={1} gap="20px" >
                  {/* {YearFlag == "true" ? ( */}
                  <LoadingButton
                    color="secondary"
                    variant="contained"
                    type="submit"
                    loading={isLoading}
                  >
                    Save
                  </LoadingButton>
                  {/* ) : (
                    <Button
                      color="secondary"
                      variant="contained"
                      disabled={true}
                    >
                      Save
                    </Button>
                  )} */}
                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      navigate("/Apps/TR124/Check Out");
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
          <Popup
            title="Employee"
            openPopup={openEMPLOYEEPopup}
            setOpenPopup={setOpenEMPLOYEEPopup}
          >
            <Listviewpopup
              accessID="2024"
              screenName="Employee"
              childToParent={childToParent}
            />
          </Popup>
          <Popup
            title="Location"
            openPopup={openLOCATIONPopup}
            setOpenPopup={setOpenLOCATIONPopup}
          >
            <Listviewpopup
              accessID="2051"
              screenName="Location"
              childToParent={childToParent}
            />
          </Popup>
          <Popup
            title="Gate"
            openPopup={openGATEPopup}
            setOpenPopup={setOpenGATEPopup}
          >
            <Listviewpopup
              accessID="2050"
              screenName="Gate"
              childToParent={childToParent}
            />
          </Popup>
          {/* </Box> */}
        </Paper>
      ) : (
        false
      )}
    </React.Fragment>
  );
};

export default Editcheckout;
